var internationalDeliveryOptions = {
    isSelectedInternationalAddress: false
}
var internationalDeliveryMethod;
var CheckoutInternationalAddressJs = (function ($) {
    var $radioButtons;
    var $clickElem;
    var showHideInternationalDeliveryAddress = function (target, elemSel) {
        if (target.attr("value") === internationalDeliveryMethod) {
            $(".j-checkout-address-international").show();

            const flagContainers = document.querySelectorAll('.iti__flag-container');
            const mobileQuery = window.matchMedia('(max-width: 767px)');

            if (flagContainers.length > 1 && mobileQuery.matches && navigator.userAgent.includes('Firefox')) {
                flagContainers[1].removeAttribute("style");

                setTimeout(function () {
                    flagContainers[1].style.left = 'auto';
                    flagContainers[1].style.top = '34px';
                }, 10);

            }
        } else {
            $(".j-checkout-address-international").hide();
        }
    };

    var initShowHideInternationalDel = function (radioButtonsSel, elemSel) {
        var radioBSel = radioButtonsSel + " input[type='radio']";
        showHideInternationalDeliveryAddress($(radioBSel + '[name=deliveryMethod]:checked'), ".j-checkout-address-international");
        $(radioBSel).on("click", function () {
            showHideInternationalDeliveryAddress($(this), elemSel);
        });
    };

    return {
        initShowHideInternationalDel: initShowHideInternationalDel,
        showHideInternationalDeliveryAddress: showHideInternationalDeliveryAddress
    }
})(jQuery);

$(document).ready(function () {
    if (typeof $("#internationalRadioButton") !== 'undefined' && typeof $("#internationalRadioButton").val() !== 'undefined') {
        internationalDeliveryMethod = $("#internationalRadioButton").val();
        CheckoutInternationalAddressJs.initShowHideInternationalDel(".j-delivery-method-radio-buttons", ".j-checkout-address-international");
    }
});